import { render } from "./dropdowns.vue?vue&type=template&id=4145b32c"
import script from "./dropdowns.vue?vue&type=script&lang=js"
export * from "./dropdowns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__